export default "__VITE_ASSET__9258974a__"